import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import useCompanyHeader from '../../common/category/useCompanyHeader'
import EventEmitter, {
  SHOW_POPUP_BUY_REPORT,
  SHOW_POPUP_UPGRADE,
} from '../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../utils/authorization'
import { Icon } from '../html/icon'

export const DownloadCsv = ({ downloadCsv, disabled, children }) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const [isLoading, setIsLoading] = useState(false)
  const { companyHeader } = useCompanyHeader({ disableCallApi: true })

  const onClick = async () => {
    if (location.pathname.includes('/companyAnalysis')) {
      companyAnalysisAction()
    } else {
      otherAction()
    }
  }

  const companyAnalysisAction = async () => {
    if (
      AUTHORIZATION_API.companyAnalysis.downloadPanel[userType.userTypeId] ===
      AUTHORIZATION_TYPE.ALLOW
    ) {
      if (companyHeader.allowDynamicReport) {
        downloadAction()
      } else {
        EventEmitter.dispatch(SHOW_POPUP_BUY_REPORT)
      }
    } else if (
      AUTHORIZATION_API.companyAnalysis.downloadPanel[userType.userTypeId] ===
      AUTHORIZATION_TYPE.DISABLE
    ) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  const otherAction = async () => {
    downloadAction()
  }

  const downloadAction = async () => {
    if (downloadCsv && !disabled && !isLoading) {
      setIsLoading(true)
      await dispatch(downloadCsv())
      setIsLoading(false)
    }
  }

  if (children) {
    return <span onClick={onClick}>{children}</span>
  }

  return (
    <Icon
      onClick={onClick}
      className="icon-download cursorPointer"
      style={{
        color: disabled ? '#9C9C9C' : '#0553A5',
        fontSize: 16,
        pointerEvents: isLoading ? 'none' : 'auto',
      }}
    />
  )
}

DownloadCsv.propTypes = {
  children: PropTypes.node,
  downloadCsv: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

DownloadCsv.defaultProps = {
  disabled: false,
}
